import stockApi from '@/api/_stock-laboratoire'

export default {
    name: 'service-stock-article',
    data() {
        return {
            onglet: 'entries', page: 1, total: 0, per_page: 30, mouvements: [],
            stock: null, article: null, chargement: false, erreur: '', sequence: 0
        }
    },
    computed: {
        stockId() { return Number(this.$route.params.stockId) },
        articleId() { return Number(this.$route.params.articleId) },
        retour() { return this.$route.query.retour === 'laboratoire' ? '/laboratoire/stock' : '/service/stock' },
        dernierePage() { return Math.max(1, Math.ceil(this.total / this.per_page)) }
    },
    mounted() { this.charger() },
    beforeDestroy() { this.sequence++ },
    methods: {
        choisirOnglet(onglet) {
            if (this.onglet === onglet) return
            this.onglet = onglet
            this.page = 1
            this.charger()
        },
        changerPage(page) {
            if (page < 1 || page > this.dernierePage || page === this.page) return
            this.page = page
            this.charger()
        },
        async charger() {
            const sequence = ++this.sequence
            this.chargement = true
            this.erreur = ''
            try {
                const reponse = await stockApi.articleHistory(this.stockId, this.articleId, this.onglet, this.page)
                if (sequence !== this.sequence) return
                if (!reponse || reponse.success !== true || !Array.isArray(reponse.data)) throw new Error('Historique indisponible')
                this.stock = reponse.stock
                this.article = reponse.article
                this.mouvements = reponse.data
                this.total = Number(reponse.total) || 0
                this.per_page = Number(reponse.per_page) || 30
            } catch (error) {
                if (sequence === this.sequence) {
                    this.mouvements = []
                    this.erreur = error && error.response && error.response.status === 403
                        ? 'Vous n’avez pas accès à l’historique de cette armoire.'
                        : 'Impossible de charger l’historique du produit. Réessayez.'
                }
            } finally {
                if (sequence === this.sequence) this.chargement = false
            }
        },
        patient(mouvement) {
            return mouvement.patient || (mouvement.patient_id ? 'Patient n°' + mouvement.patient_id : '—')
        }
    }
}
